import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

export default function Loader({ height }) {
  return (
    <div className="container-fluid">
      <div
        className="row justify-content-center align-items-center"
        style={{ height: height || "100vh" }}
      >
        <div className="col-12 text-center">
          <Icon
            icon={"line-md:loading-twotone-loop"}
            className="loading-icon"
          />
        </div>
      </div>
    </div>
  );
}
